import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemHeaderBase } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-base';

@Component({
    selector: 'fi-news-feed-item-header-task-reminder',
    template: ` <mat-card-header class="fi-news-feed-item-header">
        <div mat-card-avatar class="fi-nf-avatar-circled">
            <a
                [fiStateSref]="FiStateNames.Task.Details"
                [fiStateSrefParams]="{ id: newsItem.Content.TaskId }"
                class="NewsFeedIcon"
            >
                <span class="fa fa-lg fa-clipboard-check"></span>
            </a>
        </div>
        <mat-card-title>
            <span
                class="cursor-pointer NewsFeedItemHeader BrandedColor"
                (click)="openUserProfileDialog(newsItem.CreatedByUserId)"
            >
                {{ newsItem.CreatedByUserName }}
            </span>
        </mat-card-title>
        <mat-card-subtitle
            class="NewsFeedTime clockCcmIcon"
            [textContent]="newsItem.ChangedOnDateTime"
        ></mat-card-subtitle>
    </mat-card-header>`,
    styleUrls: ['./news-feed-item-header-task-reminder.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemHeaderTaskReminderComponent extends NewsFeedItemHeaderBase {}
